import {Component, OnInit, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {DropdownModule} from 'primeng/dropdown';
import {DialogModule} from 'primeng/dialog';
import {TooltipModule} from 'primeng/tooltip';
import {Farm} from '@/common/interface/farm.data.model';
import {Router} from '@angular/router';
import {FarmService} from '@services/farm.service';
import {ToastrService} from 'ngx-toastr';

interface SensorSelection {
    sensorId: number | null;
}
@Component({
    selector: 'app-device-configuration',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        DropdownModule,
        DialogModule,
        TooltipModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    templateUrl: './device-configuration.component.html',
    styleUrl: './device-configuration.component.scss'
})
export class DeviceConfigurationComponent implements OnInit {
    public authToken: any;
    public displayfarm: boolean = false;

    public currentFarmId: number | null = null;
    public currentFarmHouseId: number | null = null;
    public currentPartitionId: number | null = null;
    public sensorsList: any[] = [];
    public farmHouseSensorsList: any[] = [];
    userDetail: any;
    public farms: Farm[] = [];
    public displaySensorPopup: boolean = false;
    public sensors: SensorSelection[] = [{sensorId: null}];
    public selectedFarmId: number | null = null;
    constructor(
        private farmService: FarmService,
        private toaster: ToastrService,
        private router: Router
    ) {}
    ngOnInit(): void {
        const userDetailString = localStorage.getItem('UserDetail');
        this.userDetail = userDetailString ? JSON.parse(userDetailString) : null;
        this.loadFarms();
        this.loadSensorsList();
    }

    loadFarms(): void {
        this.farmService
            .getFarmDashboardList(this.userDetail.id)
            .subscribe((data: Farm[]) => {
                this.farms = data;
                if (this.farms.length > 0) {
                    this.selectedFarmId = this.farms[0].id;
                } else {
                    this.displayfarm = true;
                }
            });
    }
    loadSensorsList(): void {
        this.farmService.getSensorsList().subscribe((sensors) => {
            this.sensorsList = sensors;
        });
    }
    GetFarmHouseSensorsList(farmId: number): void {
        this.farmService.getFarmSensorsListById(farmId).subscribe((sensors) => {
            this.farmHouseSensorsList = sensors;
        });
    }
    closeDialog(): void {
        this.displayfarm = false;
    }
    onCloseFarmDialog() {
        this.displayfarm = false;
        this.loadFarms();
    }
    selectFarm(farmId: number): void {
        this.selectedFarmId = farmId;
    }
    getFarmhouseCount(): number {
        return this.farms.reduce(
            (count, farm) => count + farm.farmHouses.length,
            0
        );
    }
    openAddSensorPopup(
        farmId: number,
        farmHouseId: number,
        partitionId: number
    ): void {
        this.GetFarmHouseSensorsList(partitionId);
        this.currentFarmId = farmId;
        this.currentFarmHouseId = farmHouseId;
        this.currentPartitionId = partitionId;
        this.sensors = [{sensorId: null}];
        this.displaySensorPopup = true;
    }

    addSensor(): void {
        this.sensors.push({sensorId: null});
    }

    removeSensor(index: number): void {
        this.sensors.splice(index, 1);
    }

    closePopup(): void {
        this.displaySensorPopup = false;
    }

   toggleSensor(sensor: any): void {
    const payload = {
        id: sensor.id,
        isEnabled: sensor.isEnabled 
    };

    this.farmService.updateSensorStatus(payload).subscribe({
        next: () => {
            this.toaster.success('Sensor status updated');
        },
        error: () => {
            this.toaster.error('Failed to update sensor');
            sensor.isEnabled = !sensor.isEnabled; // rollback
        }
    });
}
    saveSensors(): void {
        const payload = this.sensors
            .filter((sensor) => sensor.sensorId !== null)
            .map((sensor) => ({
                farmId: this.currentFarmId,
                farmHouseId: this.currentFarmHouseId,
                partitionId: this.currentPartitionId,
                sensorId: sensor.sensorId
            }));
        this.farmService.addFarmHouseSensor(payload).subscribe({
            next: (response) => {
                setTimeout(() => {
                    this.displaySensorPopup = false;
                    this.GetFarmHouseSensorsList(this.currentFarmId);
                    this.toaster.success('Sensors Added Successfully');
                }, 2000);
            },
            error: (error) => {
                setTimeout(() => {
                    this.toaster.error(error.error);
                }, 2000);
            }
        });
    }
    editFarm() {
        this.router.navigate(['/edit-farm', this.selectedFarmId]);
    }
}
